<template>
  <div>
    <kalendar :configuration="calendar_settings" :events.sync="events">
      <!-- CREATED CARD SLOT -->
      <div
        slot="created-card"
        slot-scope="{ event_information }"
        class="text-black"
      >
        <div
          class="deleteButton opacity-0 transition-opacity absolute -top-3 -right-2.5"
        >
          <FontAwesomeIcon
            :icon="['far', 'times-circle']"
            size="2x"
            class="text-secondary rounded-full bg-primary font-black cursor-pointer"
            @click="removeEvent(event_information)"
          />
        </div>
        <div class="details-card">
          <h4 class="appointment-title">{{ event_information.data.title }}</h4>
          <small>
            {{ event_information.data.description }}
          </small>
          <span class="time">
            {{ event_information.start_time | formatToHours }} -
            {{ event_information.end_time | formatToHours }}
          </span>
        </div>
      </div>
      <!-- CREATING CARD SLOT -->
      <!-- <div slot="creating-card" slot-scope="{ event_information }">
        <h4 class="appointment-title" style="text-align: left;">
          New Appointment
        </h4>
        <span class="time">
          {{ event_information.start_time | formatToHours }}
          -
          {{ event_information.end_time | formatToHours }}
        </span>
      </div> -->
      <!-- POPUP CARD SLOT -->
      <div
        slot="popup-form"
        slot-scope="{ popup_information }"
        class="text-black"
        style="display: flex; flex-direction: column;"
      >
        <h4 style="margin-bottom: 10px">
          New Appointment
        </h4>
        <input
          v-model="new_appointment['title']"
          type="text"
          name="title"
          placeholder="Title"
        />
        <textarea
          v-model="new_appointment['description']"
          type="text"
          name="description"
          placeholder="Description"
          rows="2"
        ></textarea>
        <div class="buttons">
          <button class="cancel" @click="$kalendar.closePopups()">
            Cancel
          </button>
          <button @click="addEvent(popup_information)">
            Save
          </button>
        </div>
      </div>
    </kalendar>
  </div>
</template>

<script>
import { DateTime } from "luxon";

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    events: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  data() {
    return {
      calendar_settings: {
        style: "flat_design", // ["material_design", "flat_design"]
        cell_height: 20,
        scrollToNow: true,
        current_day: new Date(),
        read_only: false,
        day_starts_at: new Date().getHours() < 9 ? new Date().getHours() : 9,
        day_ends_at: 24,
        overlap: false,
        past_event_creation: false
      },
      new_appointment: {
        title: null,
        description: null
      },
      masks: {
        weekdays: "WWW"
      }
    };
  },
  methods: {
    addEvent(popup_data) {
      let payload = {
        data: {
          title: this.new_appointment.title,
          description: this.new_appointment.description
        },
        from: popup_data.start_time,
        to: popup_data.end_time
      };

      this.$kalendar.addNewEvent(payload);
      this.$kalendar.closePopups();
      this.clearFormData();
    },
    // Remove Event
    removeEvent(kalendarEvent) {
      let day = kalendarEvent.start_time.slice(0, 10);
      this.$kalendar.removeEvent({
        day,
        key: kalendarEvent.key,
        id: kalendarEvent.kalendar_id
      });
    },
    clearFormData() {
      this.new_appointment = {
        description: null,
        title: null
      };
    }
  },
  filters: {
    formatToHours(value) {
      let dt = DateTime.fromISO(value);
      return dt.toLocaleString(DateTime.TIME_24_SIMPLE);
    }
  }
};
</script>

<style lang="postcss">
.kalendar-wrapper {
  --main-color: var(--color-secondary) !important;
  --current-day-color: var(--color-primary) !important;

  & .hour-row-identifier {
    min-width: 50px;
  }
  & .days li.day-indicator {
    min-width: 119px;
  }

  & .kalendar-day,
  & .all-day {
    & li {
      min-width: 120px;
    }
    & span {
      min-width: 50px;
    }
  }

  & .calendar-wrap {
    overflow-x: scroll;

    & .sticky-top {
      /* top: 5rem; */
      right: 0rem;
      /* overflow-y: scroll;
      width: 100%; 
      width: calc(100% + 12vw);*/
      max-width: 90vw;

      /* & .all-day {
        border-bottom: solid 0px #e5e5e5 !important;
      } */

      & .all-day li.all-today {
        background-color: var(--color-primary-shade-1) !important;
      }

      /* & .all-day li {
        border-bottom: solid 2px #e5e5e5 !important;
      } */
    }
  }

  & .is-past {
    & .created-event {
      background-color: var(--color-primary-shade-1) !important;
      border-left: solid 0px #34aadc !important;
      color: black;
    }

    & .creating-event {
      background-color: var(--color-primary-shade-2) !important;
      border-left: solid 0px #34aadc !important;
      color: black;
    }
  }

  & .event-card {
    @apply p-1;
    @apply pl-0.5;
  }

  /* & .event-card:hover .deleteButton {
    @apply opacity-100;
  } */
  & .event-card.inspecting .deleteButton {
    @apply opacity-100;
  }

  & .created-event {
    /* --card-bgcolor: var(--color-secondary);
    --previous-events: var(--color-primary); */
    background-color: var(--color-secondary) !important;
    border-left: solid 0px #34aadc !important;
    @apply rounded-md;
  }

  & .creating-event {
    background-color: var(--color-primary-shade-2) !important;
    border-left: solid 0px #34aadc !important;
    color: black;
  }
}

.week-navigator {
  border-bottom: solid 1px var(--color-secondary) !important;

  & button {
    color: var(--color-secondary) !important;
  }
}
</style>
